import React from "react";
import { Item } from "./Yuyue";
import styles from "../css/Yuyue.css";
import { Header } from "./Introduce";
import selfStyle from "../css/SampleDelivery.css";
import { request, Host, origin } from "../request";
import { Toast, ActivityIndicator } from "antd-mobile";
import { Link } from "react-router-dom";
import { Status } from "./NOrderList";
import { checkToekn } from "../tools/wechatBrower";

export default class extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    list: [],
    data: {
      datafile: "",
      wordfile: "",
    },
    loading: true,
  };

  async componentDidMount() {
    await checkToekn();

    request(
      "index/getOrder",

      { uid: localStorage.getItem("openid"), id: this.props.match.params.id },
      ({ data }) => {
        if (data.code === 1) {
          this.setState({
            data: data.data,
          });
        } else {
          Toast.fail("暂无查找到订单");
        }
      },
      (error) => {
        Toast.fail("接口错误2:" + error);
      }
    );
    request(
      "index/getOrderStatus",
      { id: this.props.match.params.id },
      ({ data }) => {
        if (data.code === 1) {
          this.setState({
            list: data.data,
          });
        } else {
          // Toast.fail("暂无查找到订单");
        }
      }
    );

    setTimeout(() => {
      this.setState({
        loading: false,
      });
    }, 1000);
  }

  render() {
    let file_name_split = this.state.data.wordfile.split("/");
    let file_name = file_name_split[file_name_split.length - 1];

    let data_name = "";
    if (this.state.data.datafile) {
      let str_list = this.state.data.datafile.split("/");
      let data_name = str_list[str_list.length - 1];
    }

    return (
      <div>
        <ActivityIndicator
          toast
          text="正在加载"
          animating={this.state.loading}
        />
        <Header text="我的服务单"></Header>
        {/* {this.state.list.length > 0 ? ( */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            paddingBottom: "15px",
          }}
        >
          <div style={{ width: "100%", flex: 1 }}>
            <div className={styles.info}>
              <div
                onClick={() => {
                  this.props.history.push("/seeOrder/" + this.state.data.id);
                }}
              >
                <Item
                  left="服务单号"
                  value={this.state.data.id}
                  disabled={true}
                  inputStyle={{color:'blue',textDecoration:'underline'}}
                ></Item>
              </div>

              <Item
                left="提交时间"
                value={this.state.data.createtime}
                disabled={true}
              ></Item>
              <div
              // onClick={() => {
              //   this.props.history.push("/OrderStatus/" + this.state.data.id);
              // }}
              >
                <Status
                  left="服务状态"
                  value={this.state.data.status}
                  disabled={true}
                ></Status>
              </div>

              <div
                onClick={() => {
                  if (this.state.data.wordfile) {
                    window.location.href =
                      Host +
                      "index/download?id=" +
                      this.state.data.id +
                      "&type=wordfile&uid=" +
                      localStorage.getItem("openid");
                  } else {
                    Toast.info("暂未提供word");
                  }
                }}
              >
                <div className={styles.item}>
                  <span className={styles.itemLeft}>{"订单下载"}</span>

                  <span style={{ fontSize: "14px", color: "violet" }}>
                    {file_name}
                  </span>
                </div>
              </div>
              <Item
                left="测试费用"
                value={
                  this.state.data.test_price == null ||this.state.data.test_price == ""
                    ? "暂未提供"
                    : this.state.data.test_price
                }
                disabled={true}
              ></Item>
              {/* <Item
                left="支付方式"
                value={
                  this.state.data.pay_type === ""
                    ? "暂未提供"
                    : this.state.data.pay_type
                }
                disabled={true}
              ></Item> */}
              <div
                onClick={() => {
                  if (this.state.data.datafile) {
                    window.location.href = origin + this.state.data.datafile;
                    // "index/download?id=" +
                    // this.state.data.id +
                    // "&type=datafile";
                  } else {
                    Toast.info("暂未提供");
                  }
                }}
              >
                <div className={styles.item}>
                  <span className={styles.itemLeft}>结果文件</span>
                  {this.state.data.datafile ? (
                    // <input
                    //   className={styles.itemRight}
                    //   value={this.state.data.datafile ? data_name : "暂未提供"}
                    //   disabled={true}
                    //   style={{ color: "blue" }}
                    // ></input>
                    <div style={{fontSize:'14px',color:'blue'}}>
                      已上传，请点击下载
                    </div>

                  ) : (
                    <input
                      className={styles.itemRight}
                      value={
                        this.state.data.datafile
                          ? this.state.data.datafile
                          : "暂未提供"
                      }
                      disabled={true}
                    ></input>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className={selfStyle.list}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                paddingBottom: "15px",
              }}
            >
              {this.state.list.map((item, index) => {
                return (
                  <div style={{ width: "100%", flex: 1 }} key={index}>
                    <div className={styles.info}>
                      <Item
                        left="创建时间"
                        value={item.createtime}
                        disabled={true}
                      ></Item>
                      <Status
                        left="服务状态"
                        value={item.new_status}
                        disabled={true}
                      ></Status>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/SampleDelivery.js